export default "__VITE_ASSET__$Q6pMPXK__"